import { combineReducers } from 'redux'
import billingTerms, { STATE_KEY as BILLING_TERMS_STATE_KEY } from './billingTerms'

export const STATE_KEY = 'billing'

const reducer = combineReducers({
	[BILLING_TERMS_STATE_KEY]: billingTerms
})

export default reducer